<template>
  <div class="signIn-content">
    <div class="setting-top-box">
      <span class="setting-top-title">签到得积分</span>
    </div>
    <div class="clearfix setting-bottom-box">
      <div class="signIn-left">
        <div class="signIn-left__top" style="display: flex">
          <div>
            <img src="~@/assets/img/setting/sign-tl.png" class="sign-tl"/>
          </div>
          <div> <img src="~@/assets/img/setting/sign-text.png" class="sign-text"/>
            <div class="sign-num">+2积分</div>
          </div>
          <div style="display: flex;flex-direction: column;margin-left: 60px;">
            <span class="setting-top-title" style="margin-bottom: 10px;">当前积分：{{ haveCount }}</span>
            <button class="btn-primary btn-sm" style="margin-left: 10%" @click="points">立即兑换</button>
          </div>
          <!--					 <router-link class="sign-link" to="/">查看积分记录</router-link>-->
        </div>
        <div class="signIn-left__bottom">
          <div class="calendar-top">{{ time.year }}/{{ time.month + 1 }}</div>
          <div class="calendar-bottom">
            <div class="calendar-row calendar-row-head clearfix">
              <div class="calendar-item" v-for="(item, index) in weeks" :key="index">
                <div class="calendar-num">{{ item }}</div>
              </div>
            </div>
            <div class="calendar-row clearfix">
              <div class="calendar-item" v-for="(item, index) in visibleDays" :key="index"
                   :class="[
									{selected: xyDay(item)},
									{unSelected: unxyDay(item)},
									{notCurrentMonth: !isCurrentMonth(item)}
								]">
                <div class="calendar-num">{{ item | dayFilter }}</div>
                <div class="calendar-text" v-show="xyDay(item)">+2</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="signIn-right">
        <div class="integral-box">
          <div class="integral-top-box">
            <img src="../../assets/img/setting/sign-jf.png"/>
          </div>
          <ul class="integral-list">
            <li v-for="item in curData_" :key="item.id">
              <div class="integral-title">
                <span class="fr"><span v-if="item.score > 0">+</span> {{ item.score }}</span>
                <span>{{ item.typeName }}</span>
              </div>
              <div class="integral-time">{{ item.createTime }}</div>
            </li>
          </ul>
          <ss-no-data v-if="!finish_ && busy_" text="数据加载中"/>
          <ss-no-data v-else-if="finish_ && busy_ && curData_.length === 0" mode="image" text="暂无相关的信息"/>
        </div>
        <ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
      </div>
    </div>
    <div class="signln_model">
      <ss-modal v-model="publishFlag">
        <div class="publish-box">
          <ul class="tab-box">
            <li v-for="(item, index) in tabList" :key="item.value" @click="changeIndex(index)"
                :class="{active: tabIndex === item.value}">{{ item.label }}
            </li>
          </ul>
          <div class="tab-item" v-if="tabIndex === 0 && !isfrom">
            <ul class="garden-list">
              <li class="clearfix product-li" v-for="item in productData" :key="item.id">
                <div class="product">
                  <div class="product">
                    <img class="poster-image" :src="item.resPicData.url | imgUrl"/>
                    <div class="product-detail">
                      <span class="">{{ item.prodName }}</span>
                      <span class="">兑换积分:{{ item.scorePrice }}</span>
                      <span class="">剩余数量:{{ item.totalStocks }}</span>
                    </div>
                  </div>
                  <div>
                    <button class="btn-primary btn-sm" style="box-shadow: 0 0 1px #0260FE" @click="exchange(item.id,item.scorePrice)">兑换</button>
                  </div>
                </div>
              </li>
            </ul>
            <ss-no-data v-if="productData.length === 0" mode="image" text="暂无相关的信息"/>
            <ssNavigation v-if="productPage.pageTotal > productPage.pageSize" :total="productPage.pageTotal"
                          v-model="productPage.curPage" :size="productPage.pageSize" @input="getProductPage" />
          </div>
          <!--        兑换记录-->
          <div class="tab-item" v-if="tabIndex === 1">
            <ul class="garden-list">
              <li class="clearfix product-li" v-for="item in exchangeEecordData" :key="item.id">
                <div class="product">
                  <div class="product">
                    <img class="poster-image" :src="item.scProd.resPicData.url | imgUrl"/>
                    <div class="product-detail">
                      <span class="">{{ item.prodName }}</span>
                      <span class="">兑换时间:{{ item.createTime }}</span>
                    </div>
                  </div>
                  <div>
                    <span class="">{{ item.statusStr }}</span>
                  </div>
                </div>
              </li>
            </ul>
            <ss-no-data v-if="exchangeEecordData.length === 0" mode="image" text="暂无相关的信息"/>
            <ssNavigation v-if="exchangeEecordPage.pageTotal > exchangeEecordPage.pageSize" :total="exchangeEecordPage.pageTotal"
                          v-model="exchangeEecordPage.curPage" :size="exchangeEecordPage.pageSize" @input="getExchangePage"/>
          </div>
          <!--        商品兑换-->
          <div class="tab-item product-tab" v-if="isfrom">
            <span style="display: none">{{ orderFrom.prodId }}</span>
            <div class="product-from">
              <label class="custom-label">数量：</label>
              <input class="custom-input" v-model="orderFrom.productNums" disabled>
            </div>
            <div class="product-from">
              <label class="custom-label">收货人：</label>
              <input class="custom-input" v-model="orderFrom.consignee">
            </div>
            <div class="product-from">
              <label class="custom-label">手机号：</label>
              <input class="custom-input" v-model="orderFrom.mobile">
            </div>
            <div class="product-from">
              <label class="custom-label">地区：</label>
              <!--            <input class="custom-input" v-model="orderFrom.mobile">-->
              <div class="signln_city">
                <city-picker  @choice-caller="changeArea"></city-picker>
              </div>
            </div>
            <div class="product-from">
              <label class="custom-label">详细地址：</label>
              <input class="custom-input" v-model="orderFrom.addrDetail">
            </div>
            <div class="signln_save">
              <button class="btn-primary btn-sm" @click="saveOrder" style="margin-left: 10%">提交</button>
              <button class="btn-primary btn-sm" @click="orderBack" style="margin-left: 10%">返回</button>
            </div>
          </div>
        </div>
      </ss-modal>
    </div>

  </div>
</template>

<script>

import ssUpload from "@/components/ss-upload/ss-upload.vue";
import cityPicker from '@/components/cityPicker/cityPicker.vue'


const getYearMonthDay = (date) => {
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  return {
    year,
    month,
    day
  }
}
const getDate = (year, month, day) => {
  return new Date(year, month, day)
}
const getCurTime = () => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  return year + '-' + (month > 9 ? month : ('0' + month)) + '-' + (day > 9 ? day : ('0' + day))
}

import listMixin from '@/mixins/list.js'

export default {
  components: {ssUpload, cityPicker},
  mixins: [listMixin],
  data() {
    return {
      curPage: 1,
      iArr: [1, 2, 3, 4, 5, 6],
      jArr: [1, 2, 3, 4, 5, 6, 7],
      endDay: getCurTime(),
      value: new Date(),
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      click_time: {},
      readySignIn: [],
      time: {
        year: getYearMonthDay(new Date()).year,
        month: getYearMonthDay(new Date()).month
      },
      pageSize: 7,
      haveCount: 0,
      publishFlag: false,
      tabIndex: 0,
      tabList: [
        {
          value: 0,
          label: '积分兑换'
        },
        {
          value: 1,
          label: '兑换记录'
        }
      ],
      productData: [],
      productPage: {
        curPage: 1,
        pageSize: 4,
      },
      exchangeEecordData: [],
      exchangeEecordPage: {
        curPage: 1,
        pageSize: 4,
      },
      isfrom: false,
      orderFrom: {
        prodId: "",
        productNums: 1,
        consignee: "",
        mobile: "",
        province: "",
        county: "",
        city: "",
        addrDetail: "",
      }
    }
  },
  filters: {
    dayFilter(val) {
      return val.getDate();
    }
  },
  computed: {
    visibleDays() { // 计算当月展示日期
      let {time: {year, month}} = this;
      let currentFirstDay = getDate(year, month, 1);
      let week = currentFirstDay.getDay();
      let startDay = currentFirstDay - week * 60 * 60 * 1000 * 24;
      let arr = [];
      for (let i = 0; i < 42; i++) {
        let day = new Date(startDay + i * 60 * 60 * 1000 * 24);
        arr.push(day)
      }
      if (new Date(arr[0]).getMonth() == new Date(arr[6]).getMonth() && new Date(arr[0]).getMonth() !== month) {
        arr.splice(0, 7);
      }
      let length = arr.length
      if (new Date(arr[length - 7]).getMonth() == new Date(arr[length - 1]).getMonth() && new Date(arr[length - 1]).getMonth() !== month) {
        arr.splice(length - 7, 7);
      }
      return arr
    },
    isMaxMouth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      return year >= this.time.year && month >= this.time.month;
    },
    xyDay() {
      return (oDay) => {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let curDay = new Date(oDay).getDate();
        return this.readySignIn.findIndex(o => o === curDay) !== -1;
      }
    },
    unxyDay() {
      return (oDay) => {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        let curDay = new Date(oDay).getDate();
        return this.readySignIn.findIndex(o => o === curDay) === -1 && curDay <= day;
      }
    },
    dateMouth_() {
      let month = this.time.month + 1;
      return this.time.year + '-' + (month > 9 ? String(month) : ('0' + month));
    }
  },
  watch: {
    dateMouth_: {
      handler(val) {
        this.signInRecord();
      }
    }
  },
  created() {
    this.signIn();
    this.scoreCenSus();
    this.getProductData();
  },
  methods: {
    async signInRecord() {
      let res = await this.$http('signInRecord', {
        dateMouth: this.dateMouth_
      });
      if (res.code === 1) {
        this.readySignIn = res.data.map(o => {
          return o.signInTimeStr.substr(8, 2) * 1;
        });
      }
    },
    async signIn() {
      let res = await this.$http('signIn');
      this.reponse = {
        code: res.code,
        msg: res.msg
      }
      this.signInRecord();
    },
    goList() {
      this.$Router.push({
        name: 'signInList'
      })
    },
    isCurrentMonth(date) { // 是否当月
      let {year, month} = getYearMonthDay(getDate(this.time.year, this.time.month, 1));
      let {year: y, month: m} = getYearMonthDay(date);
      return year === y && month === m;
    },
    isToday(date) { // 是否当天
      let {year, month, day} = getYearMonthDay(new Date());
      let {year: y, month: m, day: d} = getYearMonthDay(date);
      return year === y && month === m && day === d;
    },
    isClick(date) { // 是否是点击日期
      let {click_time} = this;
      if (!click_time.day) return false;
      let {year, month, day} = getYearMonthDay(getDate(click_time.year, click_time.month, click_time.day));
      let {year: y, month: m, day: d} = getYearMonthDay(date);
      return year === y && month === m && day === d;
    },
    clickDate(date) { // 点击日期
      let {year, month, day} = getYearMonthDay(date);
      this.click_time = {year, month, day};
      this.$emit('calendarTap', {year, month, day})
    },
    prevMonth() { // 上一月
      let {time: {year, month}} = this;
      let d = getDate(year, month, 1);
      d.setMonth(d.getMonth() - 1);
      this.time = getYearMonthDay(d);
      this.click_time = {};
    },
    nextMonth() { // 下一月
      // 获取当前的年月的日期
      let {time: {year, month}} = this;
      let d = getDate(year, month, 1);
      d.setMonth(d.getMonth() + 1);
      this.time = getYearMonthDay(d);
      this.click_time = {};
    },
    monthChange(e) {
      let {value} = e.detail;
      let timeArr = value.split('-');
      this.time = {year: timeArr[0], month: timeArr[1] - 1, day: 1};
    },
    async scoreCenSus() {
      let res = await this.$http('scoreCenSus');
      console.log(res)
      this.haveCount = res.data.haveCount;
    },
    changeIndex(index) {
      this.tabIndex = index;
      this.isfrom = false;
      if (index === 0) {
        this.productPage.curPage = 1;
        this.getProductData();
      } else {
        this.exchangeEecordPage.curPage = 1;
        this.getExchangeEecordData();
      }
      this.$forceUpdate();
    },
    points() {
      this.publishFlag = true
      /*this.$router.push({
        path: '/setting/points/'
      })*/
    },
    getProductPage(num){
      this.productPage.curPage = num;
      this.getProductData();
    },
    async getProductData() {
      let res = await this.$http('prodList', {
        page: this.productPage.curPage,
        size: this.productPage.pageSize
      });
      if (res.code === 1) {
        this.productData = res.data.content;
        this.productPage.pageTotal = res.data.totalElements;
        this.clearOrderFrom();
      }
    },
    getExchangePage(num){
      this.exchangeEecordPage.curPage = num;
      this.getExchangeEecordData();
    },
    async getExchangeEecordData() {
      let res = await this.$http('orderList', {
        page: this.exchangeEecordPage.curPage,
        size: this.exchangeEecordPage.pageSize
      });
      if (res.code === 1) {
        this.exchangeEecordData = res.data.content;
        this.exchangeEecordPage.pageTotal = res.data.totalElements;
      }
    },
    exchange(id,scorePrice) {
      this.$dialog.confirm('本次兑换需要使用'+scorePrice+'积分，确定兑换吗？',{
        okText: '确定',
        cancelText: '取消',
        reverse: true
      }).then(async () => {
        let res = await this.$http('isExchange', {
          prodId: id
        });
        if(res.code === 1){
          this.isfrom = true;
          this.orderFrom.prodId = id;
        }else{
        /*  this.$dialog.alert(res.msg, {
            okText: '我知道了'
          })*/
          this.$toast(res.msg);
        }
      }).catch(err => {
        dispatch('LoginAction', {
          params: {
            identity: params.username,
            desStr: params.password
          },
          that
        });
      })
    },
    clearOrderFrom() {
      this.orderFrom.prodId = "";
      this.orderFrom.province = "";
      this.orderFrom.city = "";
      this.orderFrom.consignee = "";
      this.orderFrom.county = "";
      this.orderFrom.addrDetail = "";
      this.orderFrom.mobile = "";
      this.orderFrom.productNums = 1;
      this.isfrom = false;
    },
    orderBack() {
      this.isfrom = false;
      this.getProductData();
    },
    async saveOrder() {
      if(this.orderFrom.prodId === null || this.orderFrom.prodId === undefined || this.orderFrom.prodId === ''){
        this.$toast("商品不能为空");
        return;
      }
      if(this.orderFrom.productNums === null || this.orderFrom.productNums === undefined || this.orderFrom.productNums === ''){
        this.$toast("数量不能为空");
        return;
      }
      if(this.orderFrom.consignee === null || this.orderFrom.consignee === undefined || this.orderFrom.consignee === ''){
        this.$toast("收货人不能为空");
        return;
      }
      if(this.orderFrom.mobile === null || this.orderFrom.mobile === undefined || this.orderFrom.mobile === ''){
        this.$toast("手机号不能为空");
        return;
      }
      if(this.orderFrom.province === null || this.orderFrom.province === undefined || this.orderFrom.province === ''){
        this.$toast("省份不能为空");
        return;
      }
      if(this.orderFrom.city === null || this.orderFrom.city === undefined || this.orderFrom.city === ''){
        this.$toast("城市不能为空");
        return;
      }
      if(this.orderFrom.county === null || this.orderFrom.county === undefined || this.orderFrom.county === ''){
        this.$toast("区县不能为空");
        return;
      }
      if(this.orderFrom.addrDetail === null || this.orderFrom.addrDetail === undefined || this.orderFrom.addrDetail === ''){
        this.$toast("详细地址不能为空");
        return;
      }
      console.log(this.orderFrom.province,this.orderFrom.city,this.orderFrom.county)
      let res = await this.$http('orderSave', {
        prodId: this.orderFrom.prodId,
        productNums: this.orderFrom.productNums,
        consignee: this.orderFrom.consignee,
        mobile: this.orderFrom.mobile,
        province: this.orderFrom.province,
        county: this.orderFrom.county,
        city: this.orderFrom.city,
        addrDetail: this.orderFrom.addrDetail,
      });
      if(res.code === 1){
        this.$toast("兑换成功");
        this.getProductData();
      }
    },
    changeArea(e) {
      let pros = ['province', 'city', 'county']
      this.orderFrom[pros[e[2]]] = e[0];
    },
  }
}
</script>

<style lang="scss">
.signln_model {
  .product {
    display: flex;
    justify-content: space-between;
    img {
      width: 100px;
      height: 100px;
    }
    button {
      width: 80px;
    }
  }
  .product-detail {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    span {
      margin-top: 10px;
    }
  }
  .product-from {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .product-li {
    margin-top: 10px;
  }
  .custom-label {
    //width: 60px;
    margin-right: 10px;
  }
  .custom-input {
    width: 80%; /* 设置输入框宽度 */
    padding: 10px; /* 设置内边距 */
    margin: 8px 0; /* 设置外边距 */
    box-sizing: border-box; /* 包含边框和内边距在宽度内 */
    border: 2px solid #ccc; /* 设置边框样式 */
    border-radius: 4px; /* 设置圆角 */
    //background-color: #f8f8f8; /* 设置背景颜色 */
    font-size: 16px; /* 设置字体大小 */
    transition: border 0.3s ease-in-out; /* 设置边框变化的过渡效果 */
    //text-align: right;
  }

  .custom-input:focus {
    border-color: #4A90E2; /* 当输入框获得焦点时的边框颜色 */
    outline: none; /* 移除默认的焦点轮廓 */
    box-shadow: 0 0 8px rgba(74, 144, 226, 0.5); /* 添加阴影效果 */
  }

  .tab-item {
    margin-top: 10px;
  }

  .publish-box {
    width: 800px;
    min-height: 700px;
    padding: 30px 60px;
    background-color: #fff;
  }
  .ss-popup {
    margin-top: -350px !important;
  }
  .signln_city{
    width: 80%;
    .city-picker{
      display: flex;
      .city-picker-item{
        flex: 1;
      }
    }
  }
  .signln_save{
    display: flex;
    justify-content: center;
    margin-top: 10%;
    button {
      margin: 0;
      margin-left: 10%;
    }
  }
}
.tab-box {
  li {
    cursor: pointer;
    display: inline-block;
    margin-right: 10px;
    width: 145px;
    height: 55px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    position: relative;
    z-index: 2;
    margin-bottom: -1px;
    text-align: center;
    line-height: 55px;
    font-size: 20px;
    font-weight: 400;
    color: #484848;

    &.active {
      color: #1A6FFE;
      border-bottom: 0;

      &::after {
        content: '';
        @include abs(-5px, 0, null, 0);
        height: 5px;
        background: #1A6FFE;
      }
    }
  }
}

.signIn-content {
  .signIn-left__bottom {
    margin-top: 32px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 10px;
    padding: 0 25px;

    .calendar-bottom {
      border-top: 1px solid #DDDDDD;
      padding-bottom: 14px;

      .calendar-row {
        text-align: center;
        min-height: 68px;

        &.calendar-row-head {
          padding-top: 10px;

          .calendar-num {
            color: #8A857C;
          }
        }

        .calendar-item {
          height: 67px;
          margin-top: 10px;
          width: 14.285714285%;
          float: left;

          &.selected {
            .calendar-num {
              color: #fff;
              background: url(../../assets/img/setting/sign-qd.png) center center / auto 100% no-repeat;
            }
          }

          &.notCurrentMonth {
            opacity: 0;
          }
        }

        .calendar-num {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #292621;
          line-height: 40px;
          height: 40px;
          margin: 0 auto;
        }

        .calendar-text {
          width: 42px;
          height: 17px;
          background: #BFBFBF;
          border-radius: 8px;
          margin: 0 auto;
          font-size: 18px;
          font-weight: 400;
          text-align: center;
          color: #FFFFFF;
          line-height: 17px;
          margin: 10px auto 0;
        }
      }
    }

    .calendar-top {
      text-align: center;
      font-size: 31px;
      font-weight: 400;
      color: #010101;
      line-height: 86px;
    }
  }

  .integral-box {
    border: 1px solid #DDDDDD;
    border-radius: 10px;

    .integral-list {
      border-top: 1px solid #DDDDDD;
      padding: 0 15px 0 8px;

      li {
        border-bottom: 1px solid #DDDDDD;
        padding: 20px 0 20px 14px;

        &:last-child {
          border-bottom: 0;
        }

        .integral-title {
          font-size: 16px;
          font-weight: 400;
          color: #101010;
          line-height: 18px;

          .fr {
            font-weight: 800;
            color: #1A6FFE;
          }
        }

        .integral-time {
          margin-top: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #B9B9B9;
          line-height: 18px;
        }
      }
    }

    .integral-top-box {
      padding: 22px 0 17px;

      img {
        width: 181px;
        margin: 0 auto;
        display: block;
      }
    }
  }

  .setting-bottom-box {
    padding: 22px 22px 22px 30px;

    .signIn-left__top {
      position: relative;
      padding: 25px 0 31px 160px;
      background: #FFFFFF;
      border: 1px solid #DDDDDD;
      border-radius: 10px;

      .sign-tl {
        @include abs(25px, null, null, 17px);
        width: 120px;
        display: block;
      }

      .sign-text {
        width: 151px;
        display: block;
      }

      .sign-num {
        width: 95px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        background: #1A6FFE;
        border: 1px solid #1A6FFE;
        border-radius: 15px;
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 13px;
      }

      .sign-link {
        @include abs(51px, 0);
        width: 143px;
        height: 37px;
        line-height: 37px;
        text-align: center;
        background: #E0EDFE;
        border-radius: 19px 0px 0px 19px;
        font-size: 16px;
        font-weight: bold;
        color: #1A6FFE;
      }
    }

    .signIn-left {
      width: 524px;
      float: left;
    }

    .signIn-right {
      width: 310px;
      float: right;
    }
  }

}
</style>
